import { ServicedStateModel } from "src/app/models/serviced-state";

export interface ServicedStatesState
{
    active: string;
    models: Record<string, ServicedStateModel>;
}

export const SERVICED_STATES_FEATURE_KEY = 'servicedStates';